import { ERIKContentService } from "@tm/data"
import { CategoryBase, CategoryDropDownProps, FileCategory } from "../models"

export function getFileCategory(file: ERIKContentService.FileMeta): number {
    if (!file.labels.length) {
        return FileCategory.Others
    }

    const category = file.labels.filter((f) => f.startsWith("category:"))?.first()

    if (!category) {
        return FileCategory.Others
    }

    const normalizedCategory = category.toLowerCase().replace("category:", "")
    const categoryKey = Object.keys(FileCategory).find((fileCategory) => fileCategory.toLowerCase() === normalizedCategory)

    return categoryKey ? FileCategory[categoryKey] : FileCategory.Others
}

export const getAllSubcategories = (translateText: (key: string | number) => string) : CategoryBase[] => {
    return Object.entries(FileCategory)
        .filter(([key]) => isNaN(Number(key)))
        .map(([key, value], index) => ({
            id: index,
            categoryName: translateText(value),
            categoryValue: value as FileCategory
        }));
}

export const getCategoryBase = (category: FileCategory, translateText: (key:string | number) => string) : CategoryBase | undefined => {
    const categories = getAllSubcategories(translateText)

    return categories.find(c => c.categoryValue === category)
}

export const getCategoryDisplayLabel = (fileCategory: FileCategory | undefined, translateText: (key: string | number) => string) => {
    if (!fileCategory) {
        fileCategory = FileCategory.None
    }

    return translateText(fileCategory.toString())
}

export const getCategories = (translateText: (key: string | number) => string) => {
    const categories: Array<CategoryDropDownProps> = [
        { id: 0, categoryName: translateText(FileCategory.Others), subCategories: [] },
        {
            id: 1,
            categoryName: translateText(31),
            subCategories: [FileCategory.CostEstimate, FileCategory.Order, FileCategory.Invoice],
        },
        {
            id: 2,
            categoryName: translateText(1652),
            subCategories: [
                FileCategory.VehicleInspectionCertificate,
                FileCategory.EmissionsTestCertificate,
                FileCategory.GasSafetyInspection,
                FileCategory.AccidentPreventionRegulations,
            ],
        },
        {
            id: 3,
            categoryName: translateText(3077),
            subCategories: [FileCategory.MaintenanceProtocol, FileCategory.AcceptanceProtocol],
        },
        {
            id: 4,
            categoryName: translateText(3017),
            subCategories: [
                FileCategory.RegistrationOfVehicle,
                FileCategory.DeregistrationOfVehicle,
                FileCategory.CompletionCertificate,
                FileCategory.TakebackCertificate,
            ],
        },
        {
            id: 5,
            categoryName: translateText(3082),
            subCategories: [FileCategory.VehicleRegistration, FileCategory.VehicleRegistrationDocument, FileCategory.TaxAssessment],
        },
        {
            id: 6,
            categoryName: translateText(3074),
            subCategories: [
                FileCategory.Policies,
                FileCategory.InsuranceRepairAuthorisation,
                FileCategory.DamageReport,
                FileCategory.RecallReplacement,
            ],
        },
        {
            id: 7,
            categoryName: translateText(12842),
            subCategories: [FileCategory.AccidentalDamage, FileCategory.PaintDamage, FileCategory.Defects],
        },
        {
            id: 8,
            categoryName: translateText(1022),
            subCategories: [FileCategory.WheelCertificates, FileCategory.DamageReport],
        },
    ]
    return categories
}